//export const mockIp = '201.50.22.40'; //BR
export const mockIp = '1.178.65.255'; //EUA
